<template>
  <div class="row">
    <div class="col-md-12">
      <h1 class="text-center">Upload Influencer Costs</h1>
      <div class="card text-center mb-4" style="max-width: 600px; margin:auto">
        <div class="card-header text-center">
          APP
        </div>
        <div class="card-body">
          <div class="form-group">
            <select class="form-control text-center" v-model="app">
              <option :value="undefined" disabled>Choose App</option>
              <option v-for="(key, value) in apps" :value="value" :key="key">{{ key }}</option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="card">
        <div class="card-header text-center">
          Add Data
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-12">
              <form action="#">
                <label>Date</label>
                <div class="form-group">
                  <input type="text" class="form-control" placeholder="YYYY-MM-DD" maxlength="10" minlength="10" v-model="date">
                </div>
                <label>Platform</label>
                <div class="form-group">
                  <input type="text" class="form-control" placeholder="Ex: FB SKAD" v-model="platform">
                </div>
                <label>Cost</label>
                <div class="form-group">
                  <input type="number" class="form-control" placeholder="0.00" v-model.number="cost">
                </div>
                <label>Campaign Name</label>
                <div class="form-group">
                  <input type="text" class="form-control" placeholder="" v-model="campaign">
                </div>
              </form>
            </div>

          </div>
        </div>
        <div class="card-footer">
          <button type="submit" class="btn btn-sm btn-fill btn-primary" @click="addRow()">Add new row to buffer</button>
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="card">
        <div class="card-header text-center">
          <h4 class="card-title">Buffer</h4>
        </div>
        <div class="card-footer text-center">
          <button type="submit" class="btn btn-sm btn-fill btn-success" @click="uploadToBigQuery">{{ uploadBtnText }}</button>
        </div>
        <div class="card-body">
          <div class="table-responsive">
            <table class="table tablesorter tablesorter-default tablesorter4f4f39ffa083a" id="simple-table" role="grid">
              <thead class=" text-primary">
                <tr role="row" class="tablesorter-headerRow">
                  <th data-column="0" class="col-md-1 tablesorter-header tablesorter-headerUnSorted" tabindex="0" scope="col" role="columnheader" aria-disabled="false" aria-controls="simple-table" unselectable="on" aria-sort="none" aria-label="Date: No sort applied, activate to apply an ascending sort" style="user-select: none;"><div class="tablesorter-header-inner">
                    DATE
                  </div></th>
                  <th data-column="1" class="col-md-7 tablesorter-header tablesorter-headerUnSorted" tabindex="0" scope="col" role="columnheader" aria-disabled="false" aria-controls="simple-table" unselectable="on" aria-sort="none" aria-label="Country: No sort applied, activate to apply an ascending sort" style="user-select: none;"><div class="tablesorter-header-inner">
                    TRACKER
                  </div></th>
                  <th class="col-md-1 text-center tablesorter-header tablesorter-headerUnSorted" data-column="2" tabindex="0" scope="col" role="columnheader" aria-disabled="false" aria-controls="simple-table" unselectable="on" aria-sort="none" aria-label="Cost: No sort applied, activate to apply an ascending sort" style="user-select: none;"><div class="tablesorter-header-inner">
                    COST
                  </div></th>
                  <th class="col-md-1 text-center tablesorter-header tablesorter-headerUnSorted" data-column="3" tabindex="0" scope="col" role="columnheader" aria-disabled="false" aria-controls="simple-table" unselectable="on" aria-sort="none" aria-label="Delete: No sort applied, activate to apply an ascending sort" style="user-select: none;">
                    <div class="tablesorter-header-inner">
                      DELETE
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody aria-live="polite" aria-relevant="all">
                <tr role="row" v-for="(item, index) in rows" :key="index">
                  <td>
                    {{ item.date }}
                  </td>
                  <td  class=" no-overflow">
                    {{ item.tracker_name}}
                  </td>
                  <td class="text-center">
                    ${{ item.cost }}
                  </td>
                  <td>
                    <div class="tablesorter-header-inner text-center">
                      <button class="btn btn-sm btn-danger" @click="removeRow(index)"> DEL </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import notify from "../util/notification";
import tokenManagerService from "../services/tokenManager";

const isLocal = window.location.href.indexOf("localhost") >= 0
const backendUrl = isLocal ? "http://localhost:5000" : ""

export default {
  name: 'InfluencerCostsPage',
  data() {
    return {
      app: undefined,
      date: undefined,
      platform: "influencer collaborations",
      cost: undefined,
      campaign: undefined,
      state: 'waiting',
      rows: []
    }
  },
  computed: {
    apps() {
      return this.$store.getters.allApps
    },
    uploadBtnText() {
      if (this.state == 'waiting'){
        return "Upload Buffer to BigQuery"
      }else if (this.state == 'uploading'){
        return "Uploading to BigQuery..."
      }
    }
  },
  methods: {
    addRow() {
      let isDateValid = true
      const date = new Date(this.date)
      if (!date.getTime()) {isDateValid = false}
      let isCostValid = !Number.isNaN(this.cost) && this.cost >= 0 
      if (!isDateValid){
        notify('Date is not valid', 'error')
        return
      }
      if (!isCostValid){
        notify('Cost is not valid', 'error')
        return
      }
      this.rows.push({
        date: this.date,
        cost: this.cost,
        tracker_name: this.platform+'::'+this.campaign,
      })
      this.date = undefined
      this.cost = undefined
      this.campaign = undefined
    },
    removeRow(index) {
      this.rows.splice(index,1)
    },
    async uploadToBigQuery() {
      if (!this.app){
        notify('Please choose an app!', "error")
      }else{
        this.state = 'uploading'
        const token = await tokenManagerService.getValidToken()
        try {
          await axios.post(`${backendUrl}/load`, {
            data: this.rows,
            app: this.app,
            // only used for defining destination table
            isRefetch: true
          }, {
            headers: {
              authorization: `Bearer ${token}`
            }
          })
          notify("Uploaded", "success")
          this.rows = []
          this.state = 'waiting'
        } catch (error) {
          console.log(error);
          notify("Couldn't upload", "error")
          this.state = 'waiting'
        }
      }
    },
  }
}
</script>

<style>
.no-overflow{
  max-width: 0;
}
  
</style>